// Remove job from blocked jobs. ******************************************************************
// pathname: /v1/job/{slug}/block
// method:   DELETE
// ************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';

/**
 * @description SWR mutation: DELETE remove job from blocked jobs. Response status ok: 204.
 * @param jobSlug - string. The slug of the job.
 * @param locale - string. The locale to use for the request. Default: 'ro'.
 * @param successCallback - function. The callback to call on success.
 * @param successToastText - string. The text to show in the success toast.
 */
export const useSwrJobRemoveFromBlocked = (jobSlug: string, locale: string = 'ro', successCallback?: () => void, successToastText?: string) => {
  // SWR mutation
  // ********************************************
  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<object, undefined>({
    url: `/v1/job/${jobSlug}/block`,
    locale,
    fetcherConfig: {
      method: 'DELETE',
    },
    apiOptions: {
      onSuccess: () => {
        // Callback
        if (successCallback) successCallback();
      },
    },
    toastsOptions: {
      showSuccessToast: true,
      successToastText,
      showErrorToast: true,
    },
  });

  // Return data
  // ********************************************
  return {
    data,
    error,
    isMutating,
    reset,
    trigger,
  };
};
